/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Actions/AzureRMActionCreator" />

import { IAzureResourcesService } from "DistributedTask/Common/AzureResourcesService/AzureResourcesService";
import { AzureRMActions } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Actions/AzureRMActions";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { ActionCreatorBase } from "DistributedTask/Flux/Actions";
import { IAzureRequestResult } from "DistributedTask/Common/AzureResourcesService/AzureResourceContracts";
import { AzureSubscription, AzureManagementGroupQueryResult, AzureMLWorkspace, AzureManagementGroup, AzureAppService } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { AzureRMKeys } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/AzureRMEndpointConstants";

import { IVssPageContext } from "VSS/Platform/Context";

export class AzureRMActionCreator extends ActionCreatorBase {
    constructor(context: IVssPageContext) {
        super();

        this._service = context.getService<IAzureResourcesService>("IAzureResourcesService");
        this._actions = ActionsHubManager.GetActionsHub<AzureRMActions>(AzureRMActions);
    }

    public initialize(instanceId?: string): void {
        this._actions = ActionsHubManager.GetActionsHub<AzureRMActions>(AzureRMActions, instanceId);
    }

    public static getKey(): string {
        return AzureRMKeys.ACTION_CREATOR_KEY;
    }

    public getAccessToken(azureSubscriptionTenantId: string): void {
        this._service.getAccessToken(azureSubscriptionTenantId).then((accessToken: string) => {
            this._actions.setAccessToken.invoke(accessToken);
        }, (error: any) => {
            this._actions.updateErrorMessage.invoke(error.message);
        });
    }

    public getAccessTokenAsync(azureSubscriptionTenantId: string): Promise<string> {
        return this._service.getAccessToken(azureSubscriptionTenantId);
    }

    public getAzureRMResourceGroups(azureSubscription: AzureSubscription, accessToken: string = "",  authenticationType: string,
        creationMode: string, scopeLevel: string, callbackRequired: boolean = false, callbackParamters: { [key: string]: string } = {}) {
        this._actions.fetchingMoreResourceGroups.invoke(true);
        this._service.getAzureRMResourceGroups(azureSubscription, accessToken, authenticationType, creationMode, scopeLevel, false, null).then((result: IAzureRequestResult) => {
            if (!!result.data) {
                this._actions.updateResourceGroupList.invoke(result.data as string[]);
            }

            this._actions.fetchingMoreResourceGroups.invoke(result.callbackRequired);

            if (result.callbackRequired) {
                this.getAzureRMResourceGroups(azureSubscription, accessToken, authenticationType, creationMode, scopeLevel, result.callbackRequired, result.callbackParameters);
            }
        }, (error: any) => {
            this._actions.fetchingMoreResourceGroups.invoke(false);
            this._actions.updateErrorMessage.invoke(error.message);
        });
    }

    public getAzureManagementGroups(): void {
        this._actions.fetchingManagementGroups.invoke(true);
        this._service.getManagementGroups().then((azureManagementGroupQueryResult: AzureManagementGroupQueryResult) => {
            if (azureManagementGroupQueryResult.errorMessage) {
                this._actions.updateErrorMessage.invoke(azureManagementGroupQueryResult.errorMessage);
            } else {
                this._actions.updateManagementGroupList.invoke(azureManagementGroupQueryResult.value);
            }
            this._actions.fetchingManagementGroups.invoke(false);
        });
    }

    public updateFetchingMoreResourceGroups(fetchingMoreResourceGroups: boolean): void {
        this._actions.fetchingMoreResourceGroups.invoke(fetchingMoreResourceGroups);
    }

    public updateResourceGroups(resourceGroups: string[]): void {
        this._actions.updateResourceGroupList.invoke(resourceGroups);
    }

    public getAzureMLWorkspaces(azureSubscription: AzureSubscription, accessToken: string = "",  authenticationType: string,
        creationMode: string, scopeLevel: string, resourceGroupName: string, callbackRequired: boolean = false, callbackParamters: { [key: string]: string } = {}) {
    
        this._service.getAzureMLWorkspaces(azureSubscription, accessToken, authenticationType, creationMode, scopeLevel, resourceGroupName, false, null).then((result: IAzureRequestResult) => {
            if (!!result.data) {
                this._actions.updateMLWorkspaceList.invoke(result.data as AzureMLWorkspace[]);
            }

            this._actions.fetchingMoreMLWorkspaces.invoke(result.callbackRequired);

            if (result.callbackRequired) {
                this.getAzureMLWorkspaces(azureSubscription, accessToken, authenticationType, creationMode, scopeLevel, resourceGroupName, result.callbackRequired, result.callbackParameters);
            }
        }, (error: any) => {
            this._actions.fetchingMoreMLWorkspaces.invoke(false);
            this._actions.updateErrorMessage.invoke(error.message);
        });
    }

    public getAzureAppServiceAndSlot(azureSubscription: AzureSubscription, accessToken: string = "",  authenticationType: string,
    creationMode: string, scopeLevel: string, resourceGroupName: string, callbackRequired: boolean = false, callbackParamters: { [key: string]: string } = {}) {

        this._service.getAzureAppServiceAndSlots(azureSubscription, accessToken, authenticationType, creationMode, scopeLevel, resourceGroupName, false, null).then((result: IAzureRequestResult) => {
            if (!!result.data) {
                this._actions.updateAppServiceAndSlotList.invoke(result.data as AzureAppService[]);
            }

            this._actions.fetchingMoreAppServiceAndSlot.invoke(result.callbackRequired);

            if (result.callbackRequired) {
                this.getAzureAppServiceAndSlot(azureSubscription, accessToken, authenticationType, creationMode, scopeLevel, resourceGroupName, result.callbackRequired, result.callbackParameters);
            }
        }, (error: any) => {
            this._actions.fetchingMoreAppServiceAndSlot.invoke(false);
            this._actions.updateErrorMessage.invoke(error.message);
        });
    }

    private _service: IAzureResourcesService;
    private _actions: AzureRMActions;
}